export default {
      id: "spam-reported-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#spam-reported",
      toString: function () {
        return this.url;
      }
    }